/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
export const CLAIM_ERROR_POPUP_MESSAGE = 'CLAIM_ERROR_POPUP_MESSAGE';
export const CLAIM_SUCCESS_MESSAGE = 'CLAIM_SUCCESS_MESSAGE';
export const CLAIM_SELECTED_NDC_TAB = 'CLAIM_SELECTED_NDC_TAB';

export const CLAIM_CATEGORY_CODE = 'CLAIM_CATEGORY_CODE';
export const CLAIM_SEARCH_BY_DRUG_NAME_TABLE_DATA =
  'CLAIM_SEARCH_BY_DRUG_NAME_TABLE_DATA';
export const CLAIM_LABELER_TABLE_DATA = 'CLAIM_LABELER_TABLE_DATA';

export const CLAIM_LABELER_DRUG_TABLE_DATA = 'CLAIM_LABELER_DRUG_TABLE_DATA';
export const CLAIM_DETAILS_TABLE_DATA = 'CLAIM_DETAILS_TABLE_DATA';
export const CLAIM_DETAILS_TABLE_ROW_SELECTED =
  'CLAIM_DETAILS_TABLE_ROW_SELECTED';
export const CUSTOM_GET_CLAIM_INFO = 'CUSTOM_GET_CLAIM_INFO';
export const CLAIM_LOADING = 'CLAIM_LOADING';
export const CLAIM_REFERENCE_DATA = 'CLAIM_REFERENCE_DATA';
export const CLAIM_PROVIDER_ID_TYPE_DROPDOWN =
  'CLAIM_PROVIDER_ID_TYPE_DROPDOWN';
export const CLAIM_CATEGORY_CODE_DROPDOWN = 'CLAIM_CATEGORY_CODE_DROPDOWN';
export const CLAIM_REBATE_PROGRAM_DROPDOWN = 'CLAIM_REBATE_PROGRAM_DROPDOWN';
export const CLAIM_CLIENT_DROPDOWN = 'CLAIM_CLIENT_DROPDOWN';
export const CLAIM_GROUP_DROPDOWN = 'CLAIM_GROUP_DROPDOWN';
export const CLAIM_PLAN_DROPDOWN = 'CLAIM_PLAN_DROPDOWN';
export const SELECTED_CLAIM = 'SELECTED_CLAIM';
export const CLAIM_SUPP_RADIO_DISABLE = 'CLAIM_SUPP_RADIO_DISABLE';

export const CLAIM_SELECT_BY_FILTER = 'CLAIM_SELECT_BY_FILTER';
export const CLAIM_GENERAL_PARAMETERS = 'CLAIM_GENERAL_PARAMETERS';
export const CLAIM_INVOICED_SELECTED = 'CLAIM_INVOICED_SELECTED';
export const CLAIM_REBATE_TYPE = 'CLAIM_REBATE_TYPE';
export const CLAIM_DETAILS_POPUP = 'CLAIM_DETAILS_POPUP';
export const CLAIM_SELECT_BY = 'CLAIM_SELECT_BY';
export const SELECTED_CLAIM_INDEX = 'SELECTED_CLAIM_INDEX';
export const SELECTED_CLAIM_FILTER = 'SELECTED_CLAIM_FILTER';
export const SELECTED_CLAIM_MODE = 'SELECTED_CLAIM_MODE';
export const CLAIM_SELECTED_RECORD_INDEX = 'CLAIM_SELECTED_RECORD_INDEX';
export const RESET_SELECT_CLAIM_DATA = 'RESET_SELECT_CLAIM_DATA';
export const RESET_SELECTED_CLAIM_DATA = 'RESET_SELECTED_CLAIM_DATA';
export const ENTERED_NDC = 'ENTERED_NDC';
export const SET_DISABLED_BUTTON = 'SET_DISABLED_BUTTON';
export const DISPUTE_RESOLUTION_TOGGLE = 'DISPUTE_RESOLUTION_TOGGLE';
export const SET_TABLE_DATA = 'SET_TABLE_DATA';
export const UNIT_LOADING = 'UNIT_LOADING';
export const UNIT_RESPONSE = 'UNIT_RESPONSE';
export const SET_EDITED_DATA = 'SET_EDITED_DATA';
export const CLAIM_EXTRA_STATE = 'CLAIM_EXTRA_STATE';
export const SET_EDITED_ROWS = 'SET_EDITED_ROWS';
export const SET_ERROR_MESSAGE = 'SET_ERROR_MESSAGE';
export const RESET_EDITED_ROWS = 'RESET_EDITED_ROWS';
export const SET_CLAIM_ID = 'SET_CLAIM_ID';
export const SET_CELL_FOCUSED_CLAIM = 'SET_CELL_FOCUSED_CLAIM';
export const GET_SINGLE_PAGE_CLAIM_DATA = 'GET_SINGLE_PAGE_CLAIM_DATA';
export const SET_SINGLE_PAGE_CLAIM_DATA = 'SET_SINGLE_PAGE_CLAIM_DATA';
export const CLEAR_REDUX_DATA_CLAIM = 'CLEAR_REDUX_DATA_CLAIM';
export const DISPLAY_CLAIM_SEARCH_TAB_DATA = 'DISPLAY_CLAIM_SEARCH_TAB_DATA';
export const SELECTED_REBATE_PROGRAM="SELECTED_REBATE_PROGRAM";

